module.exports = __webpack_public_path__ + "static/media/flags.9c74e172.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-less/themes/default/assets/images/flags.png
// module id = 925
// module chunks = 0